<template>
  <v-popover
    offset="4"
    placement="bottom"
    :autoHide="autoHide"
    trigger="manual"
    popoverClass="editable"
    :open="isOpen"
    v-on:auto-hide="isOpen=false">
    <span class="edit-button" @click="isOpen=true" @mousedown.prevent>
      <i class="edit-ellipsis fas fa-ellipsis-v"></i>
    </span>
    <template slot="popover">
      <slot></slot>
      <!-- <div class="level">
        <a
          @click="submitClicked()"
          v-close-popover="true"
          class="button button-inverse full-height level-item border-right">
          <i class="fas fa-check"></i>
        </a>
        <a
          @click="isOpen=false"
          class="button button-inverse full-height level-item border-left">
          <i class="fas fa-times"></i>
        </a>
      </div> -->
    </template>
  </v-popover>
</template>

<script>
export default {
  name: 'EditInputPopup',
  components: { },
  props: {
    id: {
      type: String,
      required: true,
    },
    autoHide: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  watch: {
    isOpen() {
      if (this.isOpen) {
        this.$emit('editable-open', { id: this.id });
      } else {
        this.$emit('editable-closed', { id: this.id });
      }
    },
  },
  methods: {
    focusEvent() {
      console.log('Focused');
    },
    async submitClicked() {
      this.$emit('editable-submit-click', { id: this.id });
      this.closePopup();
    },
    async closePopup() {
      console.log(`1 closing popup ${this.isOpen} ${this.id}`);
      this.isOpen = false;
      // debugger;
    },
  },
};
</script>

<style lang="scss" scoped>

.level-left .level-item:not(:last-child) {
    margin-right: 0;
}

a.border-left {
  border-left: 1px solid $font-color;
}

a.border-right {
  border-right: 1px solid $font-color;
}


.edit-button {
  cursor: pointer;
  padding: 0 .5rem;
}

.edit-ellipsis {
  color: $sidebar-active;
  font-size: .8rem;
}
</style>
